import PostHog from 'posthog-react-native';
import type { PostHogEventProperties } from '@posthog/core';
import Config from 'react-native-config';
import { MMKV } from 'react-native-mmkv';

const mmkv = new MMKV({ id: 'posthog' });

const mmkvStorage = {
  getItem: (key: string) => mmkv.getString(key) ?? null,
  setItem: (key: string, value: string) => mmkv.set(key, value),
};

class PostHogManager {
  private client: PostHog | null = null;

  init(): void {
    if (this.client) return;
    if (Config.POSTHOG_ENABLED !== 'true') return;
    if (!Config.POSTHOG_API_KEY) return;

    this.client = new PostHog(Config.POSTHOG_API_KEY, {
      host: Config.POSTHOG_HOST ?? 'https://eu.i.posthog.com',
      customStorage: mmkvStorage,
      captureAppLifecycleEvents: true,
    });
  }

  identify(userId: string, properties?: PostHogEventProperties): void {
    this.client?.identify(userId, properties);
  }

  reset(): void {
    this.client?.reset();
  }

  screen(name: string): void {
    this.client?.capture('$screen_view', { screen_name: name });
  }

  group(groupType: string, groupKey: string, properties?: PostHogEventProperties): void {
    this.client?.group(groupType, groupKey, properties);
  }

  capture(event: string, properties?: PostHogEventProperties): void {
    this.client?.capture(event, properties);
  }
}

export const postHog = new PostHogManager();
